import { render, staticRenderFns } from "./AdminEditClient.vue?vue&type=template&id=b6fd624c&scoped=true"
import script from "./AdminEditClient.vue?vue&type=script&lang=js"
export * from "./AdminEditClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6fd624c",
  null
  
)

export default component.exports